import { FETCH_CONNECTIONS, FILTER_CONNECTIONS, FETCH_GLOBAL_PARAMS } from "../actions/actionTypes";
import { ConnectionType } from "../constants/ConnectionType";
import { GlobalParam } from "../constants/GlobalParam";
import { toIntArray } from "../helpers/utils"

const defaultState = {
  //lista ze wszystkimi polaczeniami
  connectionList: [],
  //lista pofiltrowana połączeń
  filteredConnectionList: [],
  //domyślnie wybrany filter typu połączenia
  selectedConnectionType: ConnectionType.YES_LICENSE_CODE__YES_VERSION,
  //tablica z wersjami restauracji reprezentującymi wersje DEMO - pobrane i sparsowane z parametru globalnego FLOW_DEMO_VERSION o id = 2
  flowDemoVersionIds: []
};

export default function connectionReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_CONNECTIONS: {
      return {
        ...state,
        connectionList: action.payload,
        filteredConnectionList: filterConnections(state.selectedConnectionType, state.flowDemoVersionIds, action.payload)
      };
    }
    case FILTER_CONNECTIONS: {
      return {
        ...state,
        selectedConnectionType: action.payload,
        filteredConnectionList: filterConnections(action.payload, state.flowDemoVersionIds, state.connectionList)
      };
    }
    case FETCH_GLOBAL_PARAMS: {
      //parametr globalny zawierajacy wersje DEMO, czyli identyfikatory restauracji przedzielone przecinkiem
      let flowDemoVersion = action.payload.find(item => item.id === GlobalParam.FLOW_DEMO_VERSION.id)
      //tablica z identyfikatorami restauracji demo
      let result = [];

      //sprawdzmy czy mamy ten paramer (undefined)
      if (flowDemoVersion) {
        result = toIntArray(flowDemoVersion.value, ',')
      }

      return {
        ...state,
        flowDemoVersionIds: result
      };
    }
    default:
      return state;
  }
}

/**
 * Filtrowanie listy połączeń
 * 
 * @param {ConnectionType} selectedConnectionType wybrany typ połączenia
 * @param {Array} flowDemoVersionIds tablica z identyfikatorami restauracji DEMO
 * @param {Array} connectionList oryginalna lista połączeń
 * 
 * @return wyfiltrowaną listę połączeń w zależności do wybranego typu
 */
function filterConnections(selectedConnectionType, flowDemoVersionIds, connectionList) {

  //jeśli wybrany typ połączenia ALL - zwracmy oryginalną listę
  if (selectedConnectionType === ConnectionType.ALL) {
    return connectionList
  }

  //jeśli wybrany typ połączenia DEMO - zwracamy tylko te połączenia, które mają wymienione id restauracji z parametru globalnego 
  if (selectedConnectionType === ConnectionType.DEMO_VERSION) {
    return connectionList.filter(item => flowDemoVersionIds.includes(item.companyId))
  }

  //w innym przypadku zgodnie z wybranym typem z wykluczeniem połączeń, któe mają wymienione id restauracji z parametru globalnego
  return connectionList.filter(item =>
    item.originalConnection === selectedConnectionType.originalConnection && item.currentVersion === selectedConnectionType.currentVersion && !flowDemoVersionIds.includes(item.companyId)
  )
}